// removed by extract-text-webpack-plugin
module.exports = {"iconPicker":"selected-extra-pages---iconPicker---7ZGls","iconPickerLi":"selected-extra-pages---iconPickerLi---lS8wZ","iconPickerItem":"selected-extra-pages---iconPickerItem---3r_-n","iconPickerItemSmall":"selected-extra-pages---iconPickerItemSmall---18pun","iconPickerItemImageAuto":"selected-extra-pages---iconPickerItemImageAuto---31KZk","extraPage":"selected-extra-pages---extraPage---sfJJy","iconPickerTextWrapper":"selected-extra-pages---iconPickerTextWrapper---UN9hF","iconPickerTitle":"selected-extra-pages---iconPickerTitle---27l_9","buttonContainer":"selected-extra-pages---buttonContainer---32wCT","buttonRemove":"selected-extra-pages---buttonRemove---1-TCs","selectQuantity":"selected-extra-pages---selectQuantity---3Q6wS","thumbnailAndPreview":"selected-extra-pages---thumbnailAndPreview---3dpvT","previewIconContainer":"selected-extra-pages---previewIconContainer---2ZdaB"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047462916");
          });
      }
    }
  